/** 注入全局的 mixin 方法 */
import { MixinCopy } from './comCopy'
import { MixinsMessage } from './comMessage'
import Vue from "vue";

Vue.mixin({
  mixins: [
    MixinCopy,
    MixinsMessage
  ]
})


// WEBPACK FOOTER //
// ./src/mixins/comGlobal.js